import { IQuestionBankData } from 'interfaces/questionBank'

import { IEvaluationSection } from 'models/evaluation.model'
import api from '../..'

const getData = (id: number): Promise<IQuestionBankData> =>
  api.get(`administration/evaluations/${id}`).then(({ data }) => data)

const getSections = (id: number): Promise<IEvaluationSection[]> =>
  api.get(`administration/evaluations/${id}/sections`).then(({ data }) => data)

export const createEvaluation = (body: {
  blockInstance: {
    order: number
    lesson_id: number
  }
  evaluation: IQuestionBankData
}) => api.post<IQuestionBankData>('administration/evaluations', body)

const updateEvaluation = (
  evaluationId: number,
  evaluation: IQuestionBankData
) =>
  api.put<IQuestionBankData>(`administration/evaluations/${evaluationId}`, {
    evaluation: evaluation,
  })

export const questionBankService = {
  getData,
  getSections,
  createEvaluation,
  updateEvaluation,
}
